import { z } from 'zod';

export const countDTOSchema = z.object({
  count: z.number(),
});
